module.exports = __webpack_public_path__ + "login_dinami.19804ad9d1568e55bae8.png";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/img/login_dinami.png
// module id = ../../../../../src/assets/img/login_dinami.png
// module chunks = main